var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incident-postpone"},[_c('FormDateTimePicker',{staticClass:"mb-8",attrs:{"disabled":_vm.isDisabledDatePicker,"label":"Отложить обращение до","startDate":new Date(),"error":_vm.$v.deadline.$error},model:{value:(_vm.deadline),callback:function ($$v) {_vm.deadline=$$v},expression:"deadline"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }